export var defaultProps = {
    duration: 4500,
    placement: 'top-right',
    description: '',
};
